"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _interactionActions = require("../actions/interactionActions");

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  openModal: null
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _interactionActions.InteractionActionTypes.OPEN_MODAL, function (state, action) {
  return state.set('openModal', action.payload);
}), (0, _defineProperty2.default)(_handleActions, _interactionActions.InteractionActionTypes.CLOSE_MODAL, function () {
  return initialState;
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;